import React from 'react'
import {appFactory} from '@modifi/app'
import {clientConfig} from '@modifi/client-config'
import {
  AUTH_TYPE_USER,
  CONFIG_KEY_AUTH_TOKEN_REFRESH_INTERVAL,
} from '@modifi/plugin-authentication/register'
import {withResponsiveProvider, FullScreenLoader} from '@modifi/ui'
import ms from 'ms'
import {compose} from 'ramda'
import {withAbilityProvider, withSuspense} from './hoc'
import {initPlugins} from './plugins'
import routes from './routes'
import Layout from './layouts'
import reducers from './reducers'
import './dialogs/setup'

const getApp = async (options = {}) => {
  await initPlugins(options?.plugins)

  const hocFunc = options.useSuspense
    ? compose(withSuspense, withAbilityProvider, withResponsiveProvider)
    : compose(withAbilityProvider, withResponsiveProvider)

  clientConfig.set(CONFIG_KEY_AUTH_TOKEN_REFRESH_INTERVAL, ms('4m'))

  return appFactory({
    client: 'treseus',
    appType: AUTH_TYPE_USER,
    fullscreenLoader: () => <FullScreenLoader />,
    routes,
    reducers,
    layout: Layout,
    hoc: hocFunc,
  })
}

export default getApp
